import type { ExperimentDefinition } from "../types";

/**
 * Mock experiment definition
 */
export const mockExperiments: ExperimentDefinition[] = [
  {
    experimentId: "email-after-motivation",
    description:
      "Move email question after sleep-motivation to measure impact on completion rate",
    variants: {
      control: {
        weight: 90,
      },
      treatment: {
        weight: 10,
        variant: "reordered",
        questionOverrides: [
          {
            action: "move",
            questionId: "email",
            after: "sleep-motivation",
          },
        ],
      },
    },
  },
  // Update the question title string
  {
    experimentId: "replace-gender-question-title",
    description: "Test alternate question title for gender question",
    variants: {
      control: {
        weight: 50,
      },
      treatment: {
        weight: 50,
        variant: "alt-text",
        questionOverrides: [
          {
            action: "replace",
            questionId: "user-gender",
            propertyName: "questionTranslationKey",
            newValue: "questions.user-gender.question-alt",
          },
        ],
      },
    },
  },
  // Update an answer string
  {
    experimentId: "replace-answer-text",
    description: "Test replacing the male answer text on gender question",
    variants: {
      control: {
        weight: 50,
      },
      treatment: {
        weight: 50,
        variant: "alt-answer",
        questionOverrides: [
          {
            action: "replace",
            questionId: "user-gender",
            // answerId being present is what tells us the string change is on an answer
            answerId: "male",
            propertyName: "translationKey",
            newValue: "questions.user-gender.answers.experiment-answer",
          },
        ],
      },
    },
  },
];
